import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Star, Quote } from 'lucide-react';
import './Testimonials.css';

const Testimonials = () => {
  const testimonials = [
    {
      name: 'Sarah Johnson',
      location: 'St. Paul, MN',
      rating: 5,
      text: 'Moua\'s Auto Repair saved the day! My car broke down on my way to work and I was panicking. I called them and they were so understanding. They got me in right away and fixed my alternator the same day. The price was very reasonable and the owner was incredibly honest about what needed to be done. I can\'t thank them enough!',
      service: 'Alternator Replacement'
    },
    {
      name: 'Michael Chen',
      location: 'Maplewood, MN',
      rating: 5,
      text: 'I\'ve been taking my family\'s vehicles here for over three years now and I wouldn\'t go anywhere else. The service is consistently great, prices are always fair, and they take the time to explain everything. They\'re not trying to upsell you on things you don\'t need. A truly trustworthy shop that treats you like family.',
      service: 'General Maintenance & Repair'
    },
    {
      name: 'Jessica Martinez',
      location: 'Woodbury, MN',
      rating: 5,
      text: 'Professional service without the dealership prices! I needed my brakes done and got quotes from three places. Moua\'s was not only the most affordable, but they also explained the work clearly and had it done in one day. The staff is super friendly and you can tell they genuinely care about doing quality work.',
      service: 'Brake Service'
    },
    {
      name: 'Robert Thompson',
      location: 'Oakdale, MN',
      rating: 5,
      text: 'Honest mechanic—hard to find these days! I brought my truck in for a transmission issue, expecting the worst. They diagnosed it thoroughly and told me exactly what was wrong. They gave me options and didn\'t pressure me. The repair was done right and the price was more than fair. Great experience from start to finish.',
      service: 'Transmission Repair'
    },
    {
      name: 'Amanda Wilson',
      location: 'East St. Paul, MN',
      rating: 5,
      text: 'Best auto shop in St. Paul! I was new to the area and nervous about finding a reliable mechanic. A coworker recommended Moua\'s and I\'m so glad they did. They\'ve helped me with everything from oil changes to more serious repairs. Always friendly, always professional, always reasonably priced. I trust them completely.',
      service: 'Multiple Services'
    },
    {
      name: 'David Lee',
      location: 'Roseville, MN',
      rating: 5,
      text: 'Fast and affordable service! My check engine light came on and I needed it diagnosed quickly. They fit me in the same day, found the issue (bad oxygen sensor), and had it fixed within a couple hours. The price was great and they even checked a few other things for free. Will definitely be back.',
      service: 'Engine Diagnostics'
    },
    {
      name: 'Lisa Anderson',
      location: 'West St. Paul, MN',
      rating: 5,
      text: 'They really care about their customers. I\'m a single mom and car trouble is always stressful. The team at Moua\'s treated me with such respect and kindness. They explained everything in terms I could understand, gave me an honest assessment, and worked with my budget. I felt taken care of, not taken advantage of.',
      service: 'Suspension Repair'
    },
    {
      name: 'James Garcia',
      location: 'North St. Paul, MN',
      rating: 5,
      text: 'Quality work at reasonable prices. I\'ve worked on cars myself for years, so I know good work when I see it. Moua\'s does everything right—proper diagnostics, quality parts, and solid repairs. Their prices are fair and competitive. If you want honest service from people who know what they\'re doing, this is your place.',
      service: 'Engine Repair'
    },
    {
      name: 'Emily Rodriguez',
      location: 'Little Canada, MN',
      rating: 5,
      text: 'Same-day service when I needed it most! I had a bumper damaged in a parking lot and needed it fixed before a big trip. I called Moua\'s and they squeezed me in. They had my bumper repaired and looking great by the end of the day. Professional work and friendly staff. Highly recommend!',
      service: 'Bumper Repair'
    },
    {
      name: 'Chris Taylor',
      location: 'St. Paul, MN',
      rating: 5,
      text: 'Trustworthy and reliable. I drive for work, so my vehicle needs to be dependable. Moua\'s has been servicing my car for the past two years and I\'ve never had an issue. They\'re thorough, they communicate well, and their work is solid. I recommend them to all my coworkers. A shop you can count on.',
      service: 'Regular Maintenance'
    }
  ];

  return (
    <div className="testimonials-page">
      <Header />
      
      {/* Hero Section */}
      <section className="testimonials-hero">
        <div className="container">
          <div className="testimonials-hero-content text-center">
            <h1 className="fade-in-up">Customer Testimonials</h1>
            <p className="testimonials-hero-subtitle fade-in-up">
              Real experiences from real St. Paul drivers
            </p>
            <div className="hero-rating">
              <div className="hero-stars">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} size={32} fill="var(--color-gold)" color="var(--color-gold)" />
                ))}
              </div>
              <p className="hero-rating-text">Rated 5.0 out of 5 by our customers</p>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Grid */}
      <section className="section section-dark">
        <div className="container">
          <div className="testimonials-full-grid">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="testimonial-full-card card">
                <Quote size={40} className="quote-icon" />
                <div className="testimonial-rating-stars">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} size={18} fill="var(--color-gold)" color="var(--color-gold)" />
                  ))}
                </div>
                <p className="testimonial-full-text">"{testimonial.text}"</p>
                <div className="testimonial-footer">
                  <div className="testimonial-author-info">
                    <strong>{testimonial.name}</strong>
                    <span className="testimonial-location">{testimonial.location}</span>
                  </div>
                  <div className="testimonial-service-tag">{testimonial.service}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Trust Section */}
      <section className="section section-light">
        <div className="container">
          <div className="trust-content text-center">
            <h2>Why Customers Trust Us</h2>
            <p className="section-subtitle mb-6">
              We've built our reputation on honest service, fair pricing, and quality workmanship. These reviews reflect our commitment to treating every customer with respect and integrity.
            </p>
            <div className="trust-stats">
              <div className="trust-stat">
                <div className="trust-stat-number">5.0</div>
                <div className="trust-stat-label">Average Rating</div>
              </div>
              <div className="trust-stat">
                <div className="trust-stat-number">1000+</div>
                <div className="trust-stat-label">Happy Customers</div>
              </div>
              <div className="trust-stat">
                <div className="trust-stat-number">95%</div>
                <div className="trust-stat-label">Return Rate</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Testimonials;
